import React from 'react';
import { useQuery } from '@apollo/client';
import GET_MOMENTS from 'data/queries/get-moments.graphql.js';
import MomentBackground from 'components/molecules/moment/background';
import getMomentsFromCategories from 'utils/getMomentsFromCategories';

function getNextMoments(moments, start, count) {
    let nextMoments = [];
    let nextIndex = 0;

    for (let step = 1; step <= count; step++) {
        nextIndex = start + step;
        // If we have hit the end
        if (nextIndex === moments.length) {
            nextIndex = 0;
            // If we are past the end
        } else if (nextIndex > moments.length) {
            nextIndex = step;
        }

        if (moments[nextIndex]) {
            nextMoments.push(moments[nextIndex]);
        }
    }

    return nextMoments;
}

function getPreviousMoments(moments, start, count) {
    let previousMoments = [];
    let nextIndex = 0;

    for (let step = -1; step >= -count; step--) {
        nextIndex = start + step;

        // If we have hit the bottom
        if (nextIndex < 0) {
            nextIndex = moments.length + nextIndex;
        }

        if (moments[nextIndex]) {
            previousMoments.push(moments[nextIndex]);
        }
    }

    return previousMoments;
}

function getMoment(id, moments) {
    return moments[id * 1 - 1];
}

function getRelatedMoments(id, moments, amount) {
    let moment = null;
    let momentIndex = 0;
    let relatedMoments = [];

    if (moments.length) {
        // Get moment
        moment = getMoment(id, moments);
        // Get index
        momentIndex = moments.indexOf(moment);

        // Related moments
        relatedMoments = getNextMoments(moments, momentIndex, amount).concat(
            getPreviousMoments(moments, momentIndex, amount)
        );
    }

    return relatedMoments;
}

function MomentPageContainer({
    match: {
        params: { id },
    },
}) {
    const { loading, data } = useQuery(GET_MOMENTS);

    if (loading) {
        return false;
    }

    const rawMoments = data ? data.home.grid : [];
    const categoryOrder = data ? data.home.categoryOrder : [];
    const moments = getMomentsFromCategories(categoryOrder, rawMoments);

    const moment = getMoment(id, moments);
    const relatedMoments = getRelatedMoments(id, moments, 1);
    const nextMoment = relatedMoments[0];

    const momentNumber = id * 1;

    const momentProps = {
        number: momentNumber,
        colour: moment.theme.colour.hex,
        nextMoment,
    };

    return <MomentBackground {...momentProps} />;
}

export default MomentPageContainer;
